webpackJsonp([6],{

/***/ 519:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55546f32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__ = __webpack_require__(797);
function injectStyle (ssrContext) {
  __webpack_require__(770)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55546f32_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 533:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assets_data_viddsee_submissionStatus__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules__ = __webpack_require__(182);

/**
 * Used by all the steps component.
 *
 * This mixin make use of
 * - [this.editable]
 *   editable is computed and provided by default.
 * - [this.rules]
 *   rules used by progress tracker and form validation
 */



var stepMixin = {
  computed: {
    editable: function editable() {
      return __WEBPACK_IMPORTED_MODULE_1__assets_data_viddsee_submissionStatus__["a" /* default */].getInfo(this.value.status).editable;
    },
    editablePreReview: function editablePreReview() {
      return __WEBPACK_IMPORTED_MODULE_1__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE[this.value.status] <= __WEBPACK_IMPORTED_MODULE_1__assets_data_viddsee_submissionStatus__["a" /* default */].TYPE.pending;
    }
  },
  created: function created() {
    // Compute current step index of the child
    var currentStepIndex = parseInt(this.$route.path.split('/').splice(-1), 10) - 1;
    if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(currentStepIndex)) {
      throw new Error('Unable to compute current step index. Need to re-evaluate the implementation.');
    }

    // Set up rules for this step
    this.rules = __WEBPACK_IMPORTED_MODULE_2__rules__["a" /* default */].rules[currentStepIndex];
    if (this.rules == null) {
      throw new Error('No rules were specified for this step. Please provide at least an empty object for this step.');
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (stepMixin);

/***/ }),

/***/ 534:
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(535), __esModule: true };

/***/ }),

/***/ 535:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(536);
module.exports = __webpack_require__(1).Number.isInteger;


/***/ }),

/***/ 536:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var $export = __webpack_require__(8);

$export($export.S, 'Number', { isInteger: __webpack_require__(537) });


/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

// 20.1.2.3 Number.isInteger(number)
var isObject = __webpack_require__(19);
var floor = Math.floor;
module.exports = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor(it) === it;
};


/***/ }),

/***/ 643:
/***/ (function(module, exports) {

module.exports = {"en":{"name":"English","nativeName":"English"},"zh_hant":{"name":"Chinese (Traditional)","nativeName":"ä¸­æ–‡ (ç¹é«”)"},"zh_hans":{"name":"Chinese (Simplified)","nativeName":"ä¸­æ–‡ (ç®€ä½“)"},"ms":{"name":"Malay","nativeName":"Bahasa Melayu"},"id":{"name":"Indonesian","nativeName":"Bahasa Indonesia"},"ph":{"name":"Filipino","nativeName":"Filipino"},"th":{"name":"Thai","nativeName":"à¹„à¸—à¸¢"},"ko":{"name":"Korean","nativeName":"í•œêµ­ì–´ (éŸ“åœ‹èªž), ì¡°ì„ ë§ (æœé®®èªž)"},"ja":{"name":"Japanese","nativeName":"æ—¥æœ¬èªž"},"ab":{"name":"Abkhaz","nativeName":"Ð°Ò§ÑÑƒÐ°"},"aa":{"name":"Afar","nativeName":"Afaraf"},"af":{"name":"Afrikaans","nativeName":"Afrikaans"},"ak":{"name":"Akan","nativeName":"Akan"},"sq":{"name":"Albanian","nativeName":"Shqip"},"am":{"name":"Amharic","nativeName":"áŠ áˆ›áˆ­áŠ›"},"ar":{"name":"Arabic","nativeName":"Ø§Ù„Ø¹Ø±Ø¨ÙŠØ©"},"an":{"name":"Aragonese","nativeName":"AragonÃ©s"},"hy":{"name":"Armenian","nativeName":"Õ€Õ¡ÕµÕ¥Ö€Õ¥Õ¶"},"as":{"name":"Assamese","nativeName":"à¦…à¦¸à¦®à§€à¦¯à¦¼à¦¾"},"av":{"name":"Avaric","nativeName":"Ð°Ð²Ð°Ñ€ Ð¼Ð°Ñ†Ó€, Ð¼Ð°Ð³Ó€Ð°Ñ€ÑƒÐ» Ð¼Ð°Ñ†Ó€"},"ae":{"name":"Avestan","nativeName":"avesta"},"ay":{"name":"Aymara","nativeName":"aymar aru"},"az":{"name":"Azerbaijani","nativeName":"azÉ™rbaycan dili"},"bm":{"name":"Bambara","nativeName":"bamanankan"},"ba":{"name":"Bashkir","nativeName":"Ð±Ð°ÑˆÒ¡Ð¾Ñ€Ñ‚ Ñ‚ÐµÐ»Ðµ"},"eu":{"name":"Basque","nativeName":"euskara, euskera"},"be":{"name":"Belarusian","nativeName":"Ð‘ÐµÐ»Ð°Ñ€ÑƒÑÐºÐ°Ñ"},"bn":{"name":"Bengali","nativeName":"à¦¬à¦¾à¦‚à¦²à¦¾"},"bh":{"name":"Bihari","nativeName":"à¤­à¥‹à¤œà¤ªà¥à¤°à¥€"},"bi":{"name":"Bislama","nativeName":"Bislama"},"bs":{"name":"Bosnian","nativeName":"bosanski jezik"},"br":{"name":"Breton","nativeName":"brezhoneg"},"bg":{"name":"Bulgarian","nativeName":"Ð±ÑŠÐ»Ð³Ð°Ñ€ÑÐºÐ¸ ÐµÐ·Ð¸Ðº"},"my":{"name":"Burmese","nativeName":"á€—á€™á€¬á€…á€¬"},"ca":{"name":"Catalan; Valencian","nativeName":"CatalÃ "},"ch":{"name":"Chamorro","nativeName":"Chamoru"},"ce":{"name":"Chechen","nativeName":"Ð½Ð¾Ñ…Ñ‡Ð¸Ð¹Ð½ Ð¼Ð¾Ñ‚Ñ‚"},"ny":{"name":"Chichewa; Chewa; Nyanja","nativeName":"chiCheÅµa, chinyanja"},"cv":{"name":"Chuvash","nativeName":"Ñ‡Ó‘Ð²Ð°Ñˆ Ñ‡Ó—Ð»Ñ…Ð¸"},"kw":{"name":"Cornish","nativeName":"Kernewek"},"co":{"name":"Corsican","nativeName":"corsu, lingua corsa"},"cr":{"name":"Cree","nativeName":"á“€á¦áƒá”­ááá£"},"hr":{"name":"Croatian","nativeName":"hrvatski"},"cs":{"name":"Czech","nativeName":"Äesky, ÄeÅ¡tina"},"da":{"name":"Danish","nativeName":"dansk"},"dv":{"name":"Divehi; Dhivehi; Maldivian;","nativeName":"Þ‹Þ¨ÞˆÞ¬Þ€Þ¨"},"nl":{"name":"Dutch","nativeName":"Nederlands, Vlaams"},"eo":{"name":"Esperanto","nativeName":"Esperanto"},"et":{"name":"Estonian","nativeName":"eesti, eesti keel"},"ee":{"name":"Ewe","nativeName":"EÊ‹egbe"},"fo":{"name":"Faroese","nativeName":"fÃ¸royskt"},"fj":{"name":"Fijian","nativeName":"vosa Vakaviti"},"fi":{"name":"Finnish","nativeName":"suomi, suomen kieli"},"fr":{"name":"French","nativeName":"franÃ§ais, langue franÃ§aise"},"ff":{"name":"Fula; Fulah; Pulaar; Pular","nativeName":"Fulfulde, Pulaar, Pular"},"gl":{"name":"Galician","nativeName":"Galego"},"ka":{"name":"Georgian","nativeName":"áƒ¥áƒáƒ áƒ—áƒ£áƒšáƒ˜"},"de":{"name":"German","nativeName":"Deutsch"},"el":{"name":"Greek, Modern","nativeName":"Î•Î»Î»Î·Î½Î¹ÎºÎ¬"},"gn":{"name":"GuaranÃ­","nativeName":"AvaÃ±eáº½"},"gu":{"name":"Gujarati","nativeName":"àª—à«àªœàª°àª¾àª¤à«€"},"ht":{"name":"Haitian; Haitian Creole","nativeName":"KreyÃ²l ayisyen"},"ha":{"name":"Hausa","nativeName":"Hausa, Ù‡ÙŽÙˆÙØ³ÙŽ"},"he":{"name":"Hebrew (modern)","nativeName":"×¢×‘×¨×™×ª"},"hz":{"name":"Herero","nativeName":"Otjiherero"},"hi":{"name":"Hindi","nativeName":"à¤¹à¤¿à¤¨à¥à¤¦à¥€, à¤¹à¤¿à¤‚à¤¦à¥€"},"ho":{"name":"Hiri Motu","nativeName":"Hiri Motu"},"hu":{"name":"Hungarian","nativeName":"Magyar"},"ia":{"name":"Interlingua","nativeName":"Interlingua"},"ie":{"name":"Interlingue","nativeName":"Originally called Occidental; then Interlingue after WWII"},"ga":{"name":"Irish","nativeName":"Gaeilge"},"ig":{"name":"Igbo","nativeName":"Asá»¥sá»¥ Igbo"},"ik":{"name":"Inupiaq","nativeName":"IÃ±upiaq, IÃ±upiatun"},"io":{"name":"Ido","nativeName":"Ido"},"is":{"name":"Icelandic","nativeName":"Ãslenska"},"it":{"name":"Italian","nativeName":"Italiano"},"iu":{"name":"Inuktitut","nativeName":"áƒá“„á’ƒá‘Žá‘á‘¦"},"jv":{"name":"Javanese","nativeName":"basa Jawa"},"kl":{"name":"Kalaallisut, Greenlandic","nativeName":"kalaallisut, kalaallit oqaasii"},"kn":{"name":"Kannada","nativeName":"à²•à²¨à³à²¨à²¡"},"kr":{"name":"Kanuri","nativeName":"Kanuri"},"ks":{"name":"Kashmiri","nativeName":"à¤•à¤¶à¥à¤®à¥€à¤°à¥€, ÙƒØ´Ù…ÙŠØ±ÙŠâ€Ž"},"kk":{"name":"Kazakh","nativeName":"ÒšÐ°Ð·Ð°Ò› Ñ‚Ñ–Ð»Ñ–"},"km":{"name":"Khmer","nativeName":"áž—áž¶ážŸáž¶ážáŸ’áž˜áŸ‚ážš"},"ki":{"name":"Kikuyu, Gikuyu","nativeName":"GÄ©kÅ©yÅ©"},"rw":{"name":"Kinyarwanda","nativeName":"Ikinyarwanda"},"ky":{"name":"Kirghiz, Kyrgyz","nativeName":"ÐºÑ‹Ñ€Ð³Ñ‹Ð· Ñ‚Ð¸Ð»Ð¸"},"kv":{"name":"Komi","nativeName":"ÐºÐ¾Ð¼Ð¸ ÐºÑ‹Ð²"},"kg":{"name":"Kongo","nativeName":"KiKongo"},"ku":{"name":"Kurdish","nativeName":"KurdÃ®, ÙƒÙˆØ±Ø¯ÛŒâ€Ž"},"kj":{"name":"Kwanyama, Kuanyama","nativeName":"Kuanyama"},"la":{"name":"Latin","nativeName":"latine, lingua latina"},"lb":{"name":"Luxembourgish, Letzeburgesch","nativeName":"LÃ«tzebuergesch"},"lg":{"name":"Luganda","nativeName":"Luganda"},"li":{"name":"Limburgish, Limburgan, Limburger","nativeName":"Limburgs"},"ln":{"name":"Lingala","nativeName":"LingÃ¡la"},"lo":{"name":"Lao","nativeName":"àºžàº²àºªàº²àº¥àº²àº§"},"lt":{"name":"Lithuanian","nativeName":"lietuviÅ³ kalba"},"lu":{"name":"Luba-Katanga","nativeName":""},"lv":{"name":"Latvian","nativeName":"latvieÅ¡u valoda"},"gv":{"name":"Manx","nativeName":"Gaelg, Gailck"},"mk":{"name":"Macedonian","nativeName":"Ð¼Ð°ÐºÐµÐ´Ð¾Ð½ÑÐºÐ¸ Ñ˜Ð°Ð·Ð¸Ðº"},"mg":{"name":"Malagasy","nativeName":"Malagasy fiteny"},"ml":{"name":"Malayalam","nativeName":"à´®à´²à´¯à´¾à´³à´‚"},"mt":{"name":"Maltese","nativeName":"Malti"},"mi":{"name":"MÄori","nativeName":"te reo MÄori"},"mr":{"name":"Marathi (MarÄá¹­hÄ«)","nativeName":"à¤®à¤°à¤¾à¤ à¥€"},"mh":{"name":"Marshallese","nativeName":"Kajin MÌ§ajeÄ¼"},"mn":{"name":"Mongolian","nativeName":"Ð¼Ð¾Ð½Ð³Ð¾Ð»"},"na":{"name":"Nauru","nativeName":"EkakairÅ© Naoero"},"nv":{"name":"Navajo, Navaho","nativeName":"DinÃ© bizaad, DinÃ©kÊ¼ehÇ°Ã­"},"nb":{"name":"Norwegian BokmÃ¥l","nativeName":"Norsk bokmÃ¥l"},"nd":{"name":"North Ndebele","nativeName":"isiNdebele"},"ne":{"name":"Nepali","nativeName":"à¤¨à¥‡à¤ªà¤¾à¤²à¥€"},"ng":{"name":"Ndonga","nativeName":"Owambo"},"nn":{"name":"Norwegian Nynorsk","nativeName":"Norsk nynorsk"},"no":{"name":"Norwegian","nativeName":"Norsk"},"ii":{"name":"Nuosu","nativeName":"ê†ˆêŒ ê’¿ Nuosuhxop"},"nr":{"name":"South Ndebele","nativeName":"isiNdebele"},"oc":{"name":"Occitan","nativeName":"Occitan"},"oj":{"name":"Ojibwe, Ojibwa","nativeName":"áŠá“‚á”‘á“ˆá¯á’§áŽá“"},"cu":{"name":"Old Church Slavonic, Church Slavic, Church Slavonic, Old Bulgarian, Old Slavonic","nativeName":"Ñ©Ð·Ñ‹ÐºÑŠ ÑÐ»Ð¾Ð²Ñ£Ð½ÑŒÑÐºÑŠ"},"om":{"name":"Oromo","nativeName":"Afaan Oromoo"},"or":{"name":"Oriya","nativeName":"à¬“à¬¡à¬¼à¬¿à¬†"},"os":{"name":"Ossetian, Ossetic","nativeName":"Ð¸Ñ€Ð¾Ð½ Ã¦Ð²Ð·Ð°Ð³"},"pa":{"name":"Panjabi, Punjabi","nativeName":"à¨ªà©°à¨œà¨¾à¨¬à©€, Ù¾Ù†Ø¬Ø§Ø¨ÛŒâ€Ž"},"pi":{"name":"PÄli","nativeName":"à¤ªà¤¾à¤´à¤¿"},"fa":{"name":"Persian","nativeName":"ÙØ§Ø±Ø³ÛŒ"},"pl":{"name":"Polish","nativeName":"polski"},"ps":{"name":"Pashto, Pushto","nativeName":"Ù¾ÚšØªÙˆ"},"pt":{"name":"Portuguese","nativeName":"PortuguÃªs"},"qu":{"name":"Quechua","nativeName":"Runa Simi, Kichwa"},"rm":{"name":"Romansh","nativeName":"rumantsch grischun"},"rn":{"name":"Kirundi","nativeName":"kiRundi"},"ro":{"name":"Romanian, Moldavian, Moldovan","nativeName":"romÃ¢nÄƒ"},"ru":{"name":"Russian","nativeName":"Ñ€ÑƒÑÑÐºÐ¸Ð¹ ÑÐ·Ñ‹Ðº"},"sa":{"name":"Sanskrit (Saá¹ská¹›ta)","nativeName":"à¤¸à¤‚à¤¸à¥à¤•à¥ƒà¤¤à¤®à¥"},"sc":{"name":"Sardinian","nativeName":"sardu"},"sd":{"name":"Sindhi","nativeName":"à¤¸à¤¿à¤¨à¥à¤§à¥€, Ø³Ù†ÚŒÙŠØŒ Ø³Ù†Ø¯Ú¾ÛŒâ€Ž"},"se":{"name":"Northern Sami","nativeName":"DavvisÃ¡megiella"},"sm":{"name":"Samoan","nativeName":"gagana faa Samoa"},"sg":{"name":"Sango","nativeName":"yÃ¢ngÃ¢ tÃ® sÃ¤ngÃ¶"},"sr":{"name":"Serbian","nativeName":"ÑÑ€Ð¿ÑÐºÐ¸ Ñ˜ÐµÐ·Ð¸Ðº"},"gd":{"name":"Scottish Gaelic; Gaelic","nativeName":"GÃ idhlig"},"sn":{"name":"Shona","nativeName":"chiShona"},"si":{"name":"Sinhala, Sinhalese","nativeName":"à·ƒà·’à¶‚à·„à¶½"},"sk":{"name":"Slovak","nativeName":"slovenÄina"},"sl":{"name":"Slovene","nativeName":"slovenÅ¡Äina"},"so":{"name":"Somali","nativeName":"Soomaaliga, af Soomaali"},"st":{"name":"Southern Sotho","nativeName":"Sesotho"},"es":{"name":"Spanish; Castilian","nativeName":"espaÃ±ol, castellano"},"su":{"name":"Sundanese","nativeName":"Basa Sunda"},"sw":{"name":"Swahili","nativeName":"Kiswahili"},"ss":{"name":"Swati","nativeName":"SiSwati"},"sv":{"name":"Swedish","nativeName":"svenska"},"ta":{"name":"Tamil","nativeName":"à®¤à®®à®¿à®´à¯"},"te":{"name":"Telugu","nativeName":"à°¤à±†à°²à±à°—à±"},"tg":{"name":"Tajik","nativeName":"Ñ‚Ð¾Ò·Ð¸ÐºÓ£, toÄŸikÄ«, ØªØ§Ø¬ÛŒÚ©ÛŒâ€Ž"},"ti":{"name":"Tigrinya","nativeName":"á‰µáŒáˆ­áŠ›"},"bo":{"name":"Tibetan Standard, Tibetan, Central","nativeName":"à½–à½¼à½‘à¼‹à½¡à½²à½‚"},"tk":{"name":"Turkmen","nativeName":"TÃ¼rkmen, Ð¢Ò¯Ñ€ÐºÐ¼ÐµÐ½"},"tl":{"name":"Tagalog","nativeName":"Wikang Tagalog, áœáœ’áœƒáœ…áœ” áœ†áœ„áœŽáœ“áœ„áœ”"},"tn":{"name":"Tswana","nativeName":"Setswana"},"to":{"name":"Tonga (Tonga Islands)","nativeName":"faka Tonga"},"tr":{"name":"Turkish","nativeName":"TÃ¼rkÃ§e"},"ts":{"name":"Tsonga","nativeName":"Xitsonga"},"tt":{"name":"Tatar","nativeName":"Ñ‚Ð°Ñ‚Ð°Ñ€Ñ‡Ð°, tatarÃ§a, ØªØ§ØªØ§Ø±Ú†Ø§â€Ž"},"tw":{"name":"Twi","nativeName":"Twi"},"ty":{"name":"Tahitian","nativeName":"Reo Tahiti"},"ug":{"name":"Uighur, Uyghur","nativeName":"UyÆ£urqÉ™, Ø¦Û‡ÙŠØºÛ‡Ø±Ú†Û•â€Ž"},"uk":{"name":"Ukrainian","nativeName":"ÑƒÐºÑ€Ð°Ñ—Ð½ÑÑŒÐºÐ°"},"ur":{"name":"Urdu","nativeName":"Ø§Ø±Ø¯Ùˆ"},"uz":{"name":"Uzbek","nativeName":"zbek, ÐŽÐ·Ð±ÐµÐº, Ø£Û‡Ø²Ø¨ÛÙƒâ€Ž"},"ve":{"name":"Venda","nativeName":"Tshivená¸“a"},"vi":{"name":"Vietnamese","nativeName":"Tiáº¿ng Viá»‡t"},"vo":{"name":"VolapÃ¼k","nativeName":"VolapÃ¼k"},"wa":{"name":"Walloon","nativeName":"Walon"},"cy":{"name":"Welsh","nativeName":"Cymraeg"},"wo":{"name":"Wolof","nativeName":"Wollof"},"fy":{"name":"Western Frisian","nativeName":"Frysk"},"xh":{"name":"Xhosa","nativeName":"isiXhosa"},"yi":{"name":"Yiddish","nativeName":"×™×™Ö´×“×™×©"},"yo":{"name":"Yoruba","nativeName":"YorÃ¹bÃ¡"},"za":{"name":"Zhuang, Chuang","nativeName":"SaÉ¯ cueÅ‹Æ…, Saw cuengh"}}

/***/ }),

/***/ 729:
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 332);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file.
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate

    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 332:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(333);


/***/ }),

/***/ 333:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _src = __webpack_require__(334);

var _src2 = _interopRequireDefault(_src);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* istanbul ignore next */
_src2.default.install = function (Vue) {
  Vue.component(_src2.default.name, _src2.default);
};

exports.default = _src2.default;

/***/ }),

/***/ 334:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_index_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 335:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _uploadList = __webpack_require__(336);

var _uploadList2 = _interopRequireDefault(_uploadList);

var _upload = __webpack_require__(339);

var _upload2 = _interopRequireDefault(_upload);

var _iframeUpload = __webpack_require__(344);

var _iframeUpload2 = _interopRequireDefault(_iframeUpload);

var _progress = __webpack_require__(50);

var _progress2 = _interopRequireDefault(_progress);

var _migrating = __webpack_require__(7);

var _migrating2 = _interopRequireDefault(_migrating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function noop() {}

exports.default = {
  name: 'ElUpload',

  mixins: [_migrating2.default],

  components: {
    ElProgress: _progress2.default,
    UploadList: _uploadList2.default,
    Upload: _upload2.default,
    IframeUpload: _iframeUpload2.default
  },

  provide: {
    uploader: undefined
  },

  props: {
    action: {
      type: String,
      required: true
    },
    headers: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    data: Object,
    multiple: Boolean,
    name: {
      type: String,
      default: 'file'
    },
    drag: Boolean,
    dragger: Boolean,
    withCredentials: Boolean,
    showFileList: {
      type: Boolean,
      default: true
    },
    accept: String,
    type: {
      type: String,
      default: 'select'
    },
    beforeUpload: Function,
    beforeRemove: Function,
    onRemove: {
      type: Function,
      default: noop
    },
    onChange: {
      type: Function,
      default: noop
    },
    onPreview: {
      type: Function
    },
    onSuccess: {
      type: Function,
      default: noop
    },
    onProgress: {
      type: Function,
      default: noop
    },
    onError: {
      type: Function,
      default: noop
    },
    fileList: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    autoUpload: {
      type: Boolean,
      default: true
    },
    listType: {
      type: String,
      default: 'text' // text,picture,picture-card
    },
    httpRequest: Function,
    disabled: Boolean,
    limit: Number,
    onExceed: {
      type: Function,
      default: noop
    }
  },

  data: function data() {
    return {
      uploadFiles: [],
      dragOver: false,
      draging: false,
      tempIndex: 1
    };
  },


  watch: {
    fileList: {
      immediate: true,
      handler: function handler(fileList) {
        var _this = this;

        this.uploadFiles = fileList.map(function (item) {
          item.uid = item.uid || Date.now() + _this.tempIndex++;
          item.status = 'success';
          return item;
        });
      }
    }
  },

  methods: {
    handleStart: function handleStart(rawFile) {
      rawFile.uid = Date.now() + this.tempIndex++;
      var file = {
        status: 'ready',
        name: rawFile.name,
        size: rawFile.size,
        percentage: 0,
        uid: rawFile.uid,
        raw: rawFile
      };

      try {
        file.url = URL.createObjectURL(rawFile);
      } catch (err) {
        console.error(err);
        return;
      }

      this.uploadFiles.push(file);
      this.onChange(file, this.uploadFiles);
    },
    handleProgress: function handleProgress(ev, rawFile) {
      var file = this.getFile(rawFile);
      this.onProgress(ev, file, this.uploadFiles);
      file.status = 'uploading';
      file.percentage = ev.percent || 0;
    },
    handleSuccess: function handleSuccess(res, rawFile) {
      var file = this.getFile(rawFile);

      if (file) {
        file.status = 'success';
        file.response = res;

        this.onSuccess(res, file, this.uploadFiles);
        this.onChange(file, this.uploadFiles);
      }
    },
    handleError: function handleError(err, rawFile) {
      var file = this.getFile(rawFile);
      var fileList = this.uploadFiles;

      file.status = 'fail';

      fileList.splice(fileList.indexOf(file), 1);

      this.onError(err, file, this.uploadFiles);
      this.onChange(file, this.uploadFiles);
    },
    handleRemove: function handleRemove(file, raw) {
      var _this2 = this;

      if (raw) {
        file = this.getFile(raw);
      }
      var doRemove = function doRemove() {
        _this2.abort(file);
        var fileList = _this2.uploadFiles;
        fileList.splice(fileList.indexOf(file), 1);
        _this2.onRemove(file, fileList);
      };

      if (!this.beforeRemove) {
        doRemove();
      } else if (typeof this.beforeRemove === 'function') {
        var before = this.beforeRemove(file, this.uploadFiles);
        if (before && before.then) {
          before.then(function () {
            doRemove();
          }, noop);
        } else if (before !== false) {
          doRemove();
        }
      }
    },
    getFile: function getFile(rawFile) {
      var fileList = this.uploadFiles;
      var target = void 0;
      fileList.every(function (item) {
        target = rawFile.uid === item.uid ? item : null;
        return !target;
      });
      return target;
    },
    abort: function abort(file) {
      this.$refs['upload-inner'].abort(file);
    },
    clearFiles: function clearFiles() {
      this.uploadFiles = [];
    },
    submit: function submit() {
      var _this3 = this;

      this.uploadFiles.filter(function (file) {
        return file.status === 'ready';
      }).forEach(function (file) {
        _this3.$refs['upload-inner'].upload(file.raw);
      });
    },
    getMigratingConfig: function getMigratingConfig() {
      return {
        props: {
          'default-file-list': 'default-file-list is renamed to file-list.',
          'show-upload-list': 'show-upload-list is renamed to show-file-list.',
          'thumbnail-mode': 'thumbnail-mode has been deprecated, you can implement the same effect according to this case: http://element.eleme.io/#/zh-CN/component/upload#yong-hu-tou-xiang-shang-chuan'
        }
      };
    }
  },

  render: function render(h) {
    var uploadList = void 0;

    if (this.showFileList) {
      uploadList = h(
        _uploadList2.default,
        {
          attrs: {
            disabled: this.disabled,
            listType: this.listType,
            files: this.uploadFiles,

            handlePreview: this.onPreview },
          on: {
            'remove': this.handleRemove
          }
        },
        []
      );
    }

    var uploadData = {
      props: {
        type: this.type,
        drag: this.drag,
        action: this.action,
        multiple: this.multiple,
        'before-upload': this.beforeUpload,
        'with-credentials': this.withCredentials,
        headers: this.headers,
        name: this.name,
        data: this.data,
        accept: this.accept,
        fileList: this.uploadFiles,
        autoUpload: this.autoUpload,
        listType: this.listType,
        disabled: this.disabled,
        limit: this.limit,
        'on-exceed': this.onExceed,
        'on-start': this.handleStart,
        'on-progress': this.handleProgress,
        'on-success': this.handleSuccess,
        'on-error': this.handleError,
        'on-preview': this.onPreview,
        'on-remove': this.handleRemove,
        'http-request': this.httpRequest
      },
      ref: 'upload-inner'
    };

    var trigger = this.$slots.trigger || this.$slots.default;
    var uploadComponent = typeof FormData !== 'undefined' || this.$isServer ? h(
      'upload',
      uploadData,
      [trigger]
    ) : h(
      'iframeUpload',
      uploadData,
      [trigger]
    );

    return h(
      'div',
      null,
      [this.listType === 'picture-card' ? uploadList : '', this.$slots.trigger ? [uploadComponent, this.$slots.default] : uploadComponent, this.$slots.tip, this.listType !== 'picture-card' ? uploadList : '']
    );
  }
};

/***/ }),

/***/ 336:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue__ = __webpack_require__(337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43fbf886_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_list_vue__ = __webpack_require__(338);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_list_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43fbf886_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_list_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 337:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _locale = __webpack_require__(4);

var _locale2 = _interopRequireDefault(_locale);

var _progress = __webpack_require__(50);

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  mixins: [_locale2.default],

  data: function data() {
    return {
      focusing: false
    };
  },

  components: { ElProgress: _progress2.default },

  props: {
    files: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    disabled: {
      type: Boolean,
      default: false
    },
    handlePreview: Function,
    listType: String
  },
  methods: {
    parsePercentage: function parsePercentage(val) {
      return parseInt(val, 10);
    },
    handleClick: function handleClick(file) {
      this.handlePreview && this.handlePreview(file);
    }
  }
};

/***/ }),

/***/ 338:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{class:[
    'el-upload-list',
    'el-upload-list--' + _vm.listType,
    { 'is-disabled': _vm.disabled }
  ],attrs:{"tag":"ul","name":"el-list"}},_vm._l((_vm.files),function(file,index){return _c('li',{key:index,class:['el-upload-list__item', 'is-' + file.status, _vm.focusing ? 'focusing' : ''],attrs:{"tabindex":"0"},on:{"keydown":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"delete",[8,46],$event.key)){ return null; }!_vm.disabled && _vm.$emit('remove', file)},"focus":function($event){_vm.focusing = true},"blur":function($event){_vm.focusing = false},"click":function($event){_vm.focusing = false}}},[(file.status !== 'uploading' && ['picture-card', 'picture'].indexOf(_vm.listType) > -1)?_c('img',{staticClass:"el-upload-list__item-thumbnail",attrs:{"src":file.url,"alt":""}}):_vm._e(),_c('a',{staticClass:"el-upload-list__item-name",on:{"click":function($event){_vm.handleClick(file)}}},[_c('i',{staticClass:"el-icon-document"}),_vm._v(_vm._s(file.name)+"\n    ")]),_c('label',{staticClass:"el-upload-list__item-status-label"},[_c('i',{class:{
        'el-icon-upload-success': true,
        'el-icon-circle-check': _vm.listType === 'text',
        'el-icon-check': ['picture-card', 'picture'].indexOf(_vm.listType) > -1
      }})]),(!_vm.disabled)?_c('i',{staticClass:"el-icon-close",on:{"click":function($event){_vm.$emit('remove', file)}}}):_vm._e(),(!_vm.disabled)?_c('i',{staticClass:"el-icon-close-tip"},[_vm._v(_vm._s(_vm.t('el.upload.deleteTip')))]):_vm._e(),(file.status === 'uploading')?_c('el-progress',{attrs:{"type":_vm.listType === 'picture-card' ? 'circle' : 'line',"stroke-width":_vm.listType === 'picture-card' ? 6 : 2,"percentage":_vm.parsePercentage(file.percentage)}}):_vm._e(),(_vm.listType === 'picture-card')?_c('span',{staticClass:"el-upload-list__item-actions"},[(_vm.handlePreview && _vm.listType === 'picture-card')?_c('span',{staticClass:"el-upload-list__item-preview",on:{"click":function($event){_vm.handlePreview(file)}}},[_c('i',{staticClass:"el-icon-zoom-in"})]):_vm._e(),(!_vm.disabled)?_c('span',{staticClass:"el-upload-list__item-delete",on:{"click":function($event){_vm.$emit('remove', file)}}},[_c('i',{staticClass:"el-icon-delete"})]):_vm._e()]):_vm._e()],1)}))}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 339:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__ = __webpack_require__(340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 340:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _babelHelperVueJsxMergeProps = __webpack_require__(44);

var _babelHelperVueJsxMergeProps2 = _interopRequireDefault(_babelHelperVueJsxMergeProps);

var _ajax = __webpack_require__(341);

var _ajax2 = _interopRequireDefault(_ajax);

var _uploadDragger = __webpack_require__(51);

var _uploadDragger2 = _interopRequireDefault(_uploadDragger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  inject: ['uploader'],
  components: {
    UploadDragger: _uploadDragger2.default
  },
  props: {
    type: String,
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'file'
    },
    data: Object,
    headers: Object,
    withCredentials: Boolean,
    multiple: Boolean,
    accept: String,
    onStart: Function,
    onProgress: Function,
    onSuccess: Function,
    onError: Function,
    beforeUpload: Function,
    drag: Boolean,
    onPreview: {
      type: Function,
      default: function _default() {}
    },
    onRemove: {
      type: Function,
      default: function _default() {}
    },
    fileList: Array,
    autoUpload: Boolean,
    listType: String,
    httpRequest: {
      type: Function,
      default: _ajax2.default
    },
    disabled: Boolean,
    limit: Number,
    onExceed: Function
  },

  data: function data() {
    return {
      mouseover: false,
      reqs: {}
    };
  },


  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleChange: function handleChange(ev) {
      var files = ev.target.files;

      if (!files) return;
      this.uploadFiles(files);
    },
    uploadFiles: function uploadFiles(files) {
      var _this = this;

      if (this.limit && this.fileList.length + files.length > this.limit) {
        this.onExceed && this.onExceed(files, this.fileList);
        return;
      }

      var postFiles = Array.prototype.slice.call(files);
      if (!this.multiple) {
        postFiles = postFiles.slice(0, 1);
      }

      if (postFiles.length === 0) {
        return;
      }

      postFiles.forEach(function (rawFile) {
        _this.onStart(rawFile);
        if (_this.autoUpload) _this.upload(rawFile);
      });
    },
    upload: function upload(rawFile, file) {
      var _this2 = this;

      this.$refs.input.value = null;

      if (!this.beforeUpload) {
        return this.post(rawFile);
      }

      var before = this.beforeUpload(rawFile);
      if (before && before.then) {
        before.then(function (processedFile) {
          var fileType = Object.prototype.toString.call(processedFile);
          if (fileType === '[object File]' || fileType === '[object Blob]') {
            _this2.post(processedFile);
          } else {
            _this2.post(rawFile);
          }
        }, function () {
          _this2.onRemove(null, rawFile);
        });
      } else if (before !== false) {
        this.post(rawFile);
      } else {
        this.onRemove(null, rawFile);
      }
    },
    abort: function abort(file) {
      var reqs = this.reqs;

      if (file) {
        var uid = file;
        if (file.uid) uid = file.uid;
        if (reqs[uid]) {
          reqs[uid].abort();
        }
      } else {
        Object.keys(reqs).forEach(function (uid) {
          if (reqs[uid]) reqs[uid].abort();
          delete reqs[uid];
        });
      }
    },
    post: function post(rawFile) {
      var _this3 = this;

      var uid = rawFile.uid;

      var options = {
        headers: this.headers,
        withCredentials: this.withCredentials,
        file: rawFile,
        data: this.data,
        filename: this.name,
        action: this.action,
        onProgress: function onProgress(e) {
          _this3.onProgress(e, rawFile);
        },
        onSuccess: function onSuccess(res) {
          _this3.onSuccess(res, rawFile);
          delete _this3.reqs[uid];
        },
        onError: function onError(err) {
          _this3.onError(err, rawFile);
          delete _this3.reqs[uid];
        }
      };
      var req = this.httpRequest(options);
      this.reqs[uid] = req;
      if (req && req.then) {
        req.then(options.onSuccess, options.onError);
      }
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.value = null;
        this.$refs.input.click();
      }
    },
    handleKeydown: function handleKeydown(e) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        this.handleClick();
      }
    }
  },

  render: function render(h) {
    var handleClick = this.handleClick,
        drag = this.drag,
        name = this.name,
        handleChange = this.handleChange,
        multiple = this.multiple,
        accept = this.accept,
        listType = this.listType,
        uploadFiles = this.uploadFiles,
        disabled = this.disabled,
        handleKeydown = this.handleKeydown;

    var data = {
      class: {
        'el-upload': true
      },
      on: {
        click: handleClick,
        keydown: handleKeydown
      }
    };
    data.class['el-upload--' + listType] = true;
    return h(
      'div',
      (0, _babelHelperVueJsxMergeProps2.default)([data, {
        attrs: { tabindex: '0' }
      }]),
      [drag ? h(
        'upload-dragger',
        {
          attrs: { disabled: disabled },
          on: {
            'file': uploadFiles
          }
        },
        [this.$slots.default]
      ) : this.$slots.default, h(
        'input',
        { 'class': 'el-upload__input', attrs: { type: 'file', name: name, multiple: multiple, accept: accept },
          ref: 'input', on: {
            'change': handleChange
          }
        },
        []
      )]
    );
  }
};

/***/ }),

/***/ 341:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = upload;
function getError(action, option, xhr) {
  var msg = void 0;
  if (xhr.response) {
    msg = '' + (xhr.response.error || xhr.response);
  } else if (xhr.responseText) {
    msg = '' + xhr.responseText;
  } else {
    msg = 'fail to post ' + action + ' ' + xhr.status;
  }

  var err = new Error(msg);
  err.status = xhr.status;
  err.method = 'post';
  err.url = action;
  return err;
}

function getBody(xhr) {
  var text = xhr.responseText || xhr.response;
  if (!text) {
    return text;
  }

  try {
    return JSON.parse(text);
  } catch (e) {
    return text;
  }
}

function upload(option) {
  if (typeof XMLHttpRequest === 'undefined') {
    return;
  }

  var xhr = new XMLHttpRequest();
  var action = option.action;

  if (xhr.upload) {
    xhr.upload.onprogress = function progress(e) {
      if (e.total > 0) {
        e.percent = e.loaded / e.total * 100;
      }
      option.onProgress(e);
    };
  }

  var formData = new FormData();

  if (option.data) {
    Object.keys(option.data).forEach(function (key) {
      formData.append(key, option.data[key]);
    });
  }

  formData.append(option.filename, option.file);

  xhr.onerror = function error(e) {
    option.onError(e);
  };

  xhr.onload = function onload() {
    if (xhr.status < 200 || xhr.status >= 300) {
      return option.onError(getError(action, option, xhr));
    }

    option.onSuccess(getBody(xhr));
  };

  xhr.open('post', action, true);

  if (option.withCredentials && 'withCredentials' in xhr) {
    xhr.withCredentials = true;
  }

  var headers = option.headers || {};

  for (var item in headers) {
    if (headers.hasOwnProperty(item) && headers[item] !== null) {
      xhr.setRequestHeader(item, headers[item]);
    }
  }
  xhr.send(formData);
  return xhr;
}

/***/ }),

/***/ 342:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
//
//
//
//
//
//
//
//
//
//
//
//
//

exports.default = {
  name: 'ElUploadDrag',
  props: {
    disabled: Boolean
  },
  data: function data() {
    return {
      dragover: false
    };
  },

  methods: {
    onDragover: function onDragover() {
      if (!this.disabled) {
        this.dragover = true;
      }
    },
    onDrop: function onDrop(e) {
      if (!this.disabled) {
        this.dragover = false;
        this.$emit('file', e.dataTransfer.files);
      }
    }
  }
};

/***/ }),

/***/ 343:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-upload-dragger",class:{
    'is-dragover': _vm.dragover
  },on:{"drop":function($event){$event.preventDefault();_vm.onDrop($event)},"dragover":function($event){$event.preventDefault();_vm.onDragover($event)},"dragleave":function($event){$event.preventDefault();_vm.dragover = false}}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 344:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue__);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */
var __vue_template__ = null
/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_iframe_upload_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _uploadDragger = __webpack_require__(51);

var _uploadDragger2 = _interopRequireDefault(_uploadDragger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    UploadDragger: _uploadDragger2.default
  },
  props: {
    type: String,
    data: {},
    action: {
      type: String,
      required: true
    },
    name: {
      type: String,
      default: 'file'
    },
    withCredentials: Boolean,
    accept: String,
    onStart: Function,
    onProgress: Function,
    onSuccess: Function,
    onError: Function,
    beforeUpload: Function,
    onPreview: {
      type: Function,
      default: function _default() {}
    },
    onRemove: {
      type: Function,
      default: function _default() {}
    },
    drag: Boolean,
    listType: String,
    disabled: Boolean,
    limit: Number,
    onExceed: Function
  },

  data: function data() {
    return {
      mouseover: false,
      domain: '',
      file: null,
      submitting: false
    };
  },


  methods: {
    isImage: function isImage(str) {
      return str.indexOf('image') !== -1;
    },
    handleClick: function handleClick() {
      if (!this.disabled) {
        this.$refs.input.click();
      }
    },
    handleChange: function handleChange(ev) {
      var file = ev.target.value;
      if (file) {
        this.uploadFiles(file);
      }
    },
    uploadFiles: function uploadFiles(file) {
      if (this.limit && this.$parent.uploadFiles.length + file.length > this.limit) {
        this.onExceed && this.onExceed(this.fileList);
        return;
      }

      if (this.submitting) return;
      this.submitting = true;
      this.file = file;
      this.onStart(file);

      var formNode = this.getFormNode();
      var dataSpan = this.getFormDataNode();
      var data = this.data;
      if (typeof data === 'function') {
        data = data(file);
      }
      var inputs = [];
      for (var key in data) {
        if (data.hasOwnProperty(key)) {
          inputs.push('<input name="' + key + '" value="' + data[key] + '"/>');
        }
      }
      dataSpan.innerHTML = inputs.join('');
      formNode.submit();
      dataSpan.innerHTML = '';
    },
    getFormNode: function getFormNode() {
      return this.$refs.form;
    },
    getFormDataNode: function getFormDataNode() {
      return this.$refs.data;
    }
  },

  created: function created() {
    this.frameName = 'frame-' + Date.now();
  },
  mounted: function mounted() {
    var self = this;
    !this.$isServer && window.addEventListener('message', function (event) {
      if (!self.file) return;
      var targetOrigin = new URL(self.action).origin;
      if (event.origin !== targetOrigin) return;
      var response = event.data;
      if (response.result === 'success') {
        self.onSuccess(response, self.file);
      } else if (response.result === 'failed') {
        self.onError(response, self.file);
      }
      self.submitting = false;
      self.file = null;
    }, false);
  },
  render: function render(h) {
    var drag = this.drag,
        uploadFiles = this.uploadFiles,
        listType = this.listType,
        frameName = this.frameName,
        disabled = this.disabled;

    var oClass = { 'el-upload': true };
    oClass['el-upload--' + listType] = true;

    return h(
      'div',
      {
        'class': oClass,
        on: {
          'click': this.handleClick
        },
        nativeOn: {
          'drop': this.onDrop,
          'dragover': this.handleDragover,
          'dragleave': this.handleDragleave
        }
      },
      [h(
        'iframe',
        {
          on: {
            'load': this.onload
          },

          ref: 'iframe',
          attrs: { name: frameName
          }
        },
        []
      ), h(
        'form',
        { ref: 'form', attrs: { action: this.action, target: frameName, enctype: 'multipart/form-data', method: 'POST' }
        },
        [h(
          'input',
          {
            'class': 'el-upload__input',
            attrs: { type: 'file',

              name: 'file',

              accept: this.accept },
            ref: 'input', on: {
              'change': this.handleChange
            }
          },
          []
        ), h(
          'input',
          {
            attrs: { type: 'hidden', name: 'documentDomain', value: this.$isServer ? '' : document.domain }
          },
          []
        ), h(
          'span',
          { ref: 'data' },
          []
        )]
      ), drag ? h(
        'upload-dragger',
        {
          on: {
            'file': uploadFiles
          },
          attrs: { disabled: disabled }
        },
        [this.$slots.default]
      ) : this.$slots.default]
    );
  }
};

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __webpack_require__(101);

/***/ }),

/***/ 44:
/***/ (function(module, exports) {

module.exports = __webpack_require__(773);

/***/ }),

/***/ 50:
/***/ (function(module, exports) {

module.exports = __webpack_require__(200);

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue__ = __webpack_require__(342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4d91e8_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_dragger_vue__ = __webpack_require__(343);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_upload_dragger_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4d91e8_hasScoped_false_preserveWhitespace_false_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_upload_dragger_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = __webpack_require__(42);

/***/ })

/******/ });

/***/ }),

/***/ 730:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMediaItemHeader_vue__ = __webpack_require__(788);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b5dc02_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMediaItemHeader_vue__ = __webpack_require__(789);
function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMediaItemHeader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_18b5dc02_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMediaItemHeader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMediaItemDescription_vue__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d325550c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMediaItemDescription_vue__ = __webpack_require__(793);
function injectStyle (ssrContext) {
  __webpack_require__(790)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMediaItemDescription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d325550c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMediaItemDescription_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 732:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMediaItemListEmptyState_vue__ = __webpack_require__(794);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f8ad18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMediaItemListEmptyState_vue__ = __webpack_require__(795);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMediaItemListEmptyState_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_77f8ad18_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMediaItemListEmptyState_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 770:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(771);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("5aaac2a2", content, true);

/***/ }),

/***/ 771:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".empty-data{font-size:.8em;opacity:.6}.submission__file-media .el-upload{text-align:left}.submission__file-media .el-upload.el-upload--picture-card{text-align:center}.submission__file-media .el-upload-list--picture-card,.submission__file-media .el-upload-list__item-thumbnail{-o-object-fit:cover;object-fit:cover}.file-media__item{margin-bottom:2em}.margin-bottom_32{margin-bottom:32px}", "", {"version":3,"sources":["/app/src/components/Submission/steps/NewFilesMedia/index.vue"],"names":[],"mappings":"AAoHA,YACE,eAAiB,AACjB,UAAa,CACd,AACD,mCACE,eAAiB,CAClB,AACD,2DACE,iBAAmB,CACpB,AACD,8GAEE,oBAAqB,AAClB,gBAAkB,CACtB,AACD,kBACE,iBAAmB,CACpB,AACD,kBACE,kBAAoB,CACrB","file":"index.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.empty-data {\n  font-size: 0.8em;\n  opacity: 0.6;\n}\n.submission__file-media .el-upload {\n  text-align: left;\n}\n.submission__file-media .el-upload.el-upload--picture-card {\n  text-align: center;\n}\n.submission__file-media .el-upload-list--picture-card,\n.submission__file-media .el-upload-list__item-thumbnail {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n.file-media__item {\n  margin-bottom: 2em;\n}\n.margin-bottom_32 {\n  margin-bottom: 32px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 772:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_upload__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__libs_webcall__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_variables__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_notify_constants__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_magic_values__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FilesMedia_UploadDragShow__ = __webpack_require__(774);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FilesMedia_SubtitleUploader__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FilesMedia_FileMediaItem__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__FilesMedia_FileMediaItemHeader__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FilesMedia_FileMediaItemDescription__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FilesMedia_FileMediaItemListEmptyState__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Mixins_stepMixin__ = __webpack_require__(533);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_upload___default.a);

var categories = {
  OTHERS: 'others',
  MUSIC_LICENSE: 'music_license',
  SUBTITLES: 'subtitles',
  STILLS: 'stills',
  TRAILER: 'trailer',
  POSTERS: 'posters'
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'files',
  mixins: [__WEBPACK_IMPORTED_MODULE_13__Mixins_stepMixin__["a" /* default */]],
  components: {
    UploadDragShow: __WEBPACK_IMPORTED_MODULE_7__FilesMedia_UploadDragShow__["a" /* default */],
    SubtitleUploader: __WEBPACK_IMPORTED_MODULE_8__FilesMedia_SubtitleUploader__["a" /* default */],
    FileMediaItem: __WEBPACK_IMPORTED_MODULE_9__FilesMedia_FileMediaItem__["a" /* default */],
    FileMediaItemHeader: __WEBPACK_IMPORTED_MODULE_10__FilesMedia_FileMediaItemHeader__["a" /* default */],
    FileMediaItemDescription: __WEBPACK_IMPORTED_MODULE_11__FilesMedia_FileMediaItemDescription__["a" /* default */],
    FileMediaItemListEmptyState: __WEBPACK_IMPORTED_MODULE_12__FilesMedia_FileMediaItemListEmptyState__["a" /* default */]
  },
  props: ['value'],
  data: function data() {
    return {
      requestHeaders: __WEBPACK_IMPORTED_MODULE_3__libs_webcall__["a" /* default */].getHeader(),
      dialogImageUrl: '',
      dialogVisible: false,
      categories: categories,

      // Create a shallow copy of the items. All items in here should be self
      // managed i.e. data is manually sync and is a reflection of the
      // submission object
      // fileListForStills: this.value.image,
      fileListForOthers: this.value.attachments.filter(function (attachment) {
        return attachment.category === categories.OTHERS;
      }),
      fileListForMusicLicense: this.value.attachments.filter(function (attachment) {
        return attachment.category === categories.MUSIC_LICENSE;
      }),
      fileListForSubtitles: this.value.attachments.filter(function (attachment) {
        return attachment.category === categories.SUBTITLES;
      }),
      fileListForStills: this.value.attachments.filter(function (attachment) {
        return attachment.category === categories.STILLS;
      }),
      fileListForTrailers: this.value.attachments.filter(function (attachment) {
        return attachment.category === categories.TRAILER;
      }),
      fileListForPosters: this.value.attachments.filter(function (attachment) {
        return attachment.category === categories.POSTERS;
      })
    };
  },

  watch: {
    fileListForMedia: function fileListForMedia() {
      this.updateForm();
    },
    fileListForOthers: function fileListForOthers() {
      this.updateForm();
    },
    fileListForMusicLicense: function fileListForMusicLicense() {
      this.updateForm();
    },
    fileListForStills: function fileListForStills() {
      this.updateForm();
    },
    fileListForTrailers: function fileListForTrailers() {
      this.updateForm();
    },
    fileListForPosters: function fileListForPosters() {
      this.updateForm();
    }
  },
  methods: {
    updateForm: function updateForm() {
      // Trigger store update
      this.$emit('input');
    },
    getUploadUrl: function getUploadUrl() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'attachments';

      return __WEBPACK_IMPORTED_MODULE_4__config_variables__["a" /* default */].API_URL + 'submitvideo/' + this.value.id + '/' + type;
    },


    /**
     * Handle changes made to the attachment
     * @param {string} type of the attachment
     * @returns a callback function used by another component on its change event.
     *          null if no appropriate function is defined.
     */
    handleChange: function handleChange(type) {
      var _this = this;

      if (type === 'Subtitles') {
        /**
         * A callback function used to update the note of the attachment. The
         * note of Subtitles attachment stores the language of the subtitle.
         * @param {object} file object of the attachment
         * @param {string} note in the format of 'subtitles-{languageCode}'
         */
        // TODO: This does not confort with the current framework. i.e. web
        // update is not being handled by the parent component (submission)
        // Consequently,
        //   1. networkActivity will not be ran
        //   2. need to manually update client data (not reactive)
        return function (file, note) {
          return __WEBPACK_IMPORTED_MODULE_3__libs_webcall__["a" /* default */].submission.attachments.update(_this.value.id, file.id, {
            note: note
          })
          // Find and update the relevant attachment
          .then(function (_ref) {
            var data = _ref.data;

            var fileList = _this['fileListFor' + type];
            var index = fileList.findIndex(function (listFile) {
              return listFile.uid === file.uid;
            });
            _this.$set(fileList, index, data);
            _this.$set(_this, 'fileListFor' + type, fileList);
          }).catch(function (error) {
            // TODO: Ponder. Should we handle error notification globally from
            // webcall? Or should we do it in the relevant component individually?
            _this.$notify.error({
              title: 'Error',
              message: 'Unable to update subtitle language. Please try again later.',
              duration: __WEBPACK_IMPORTED_MODULE_5__config_notify_constants__["a" /* default */].DURATION.MEDIUM
            });
            throw error;
          });
        };
      }
      return null;
    },
    handleRemove: function handleRemove(type) {
      var _this2 = this;

      var endpoint = type === 'Media' ? 'image' : 'attachments';

      return function (file, fileList) {
        // Item may not be available on the server yet. In this case, just
        // remove it from the client side.
        if (file.status === 'uploading') {
          _this2.$set(_this2, 'fileListFor' + type, fileList);
          return;
        }
        if (file.status === 'success') {
          __WEBPACK_IMPORTED_MODULE_3__libs_webcall__["a" /* default */].submission[endpoint].delete(_this2.value.id, file.id).then(function () {
            _this2.$set(_this2, 'fileListFor' + type, fileList);
          }).catch(function (error) {
            /**
             * Most likely occur due to server or network error.
             * When this happen, restore the file that was previously deleted back to the list
             * Then inform user about the error.
             */
            _this2.$notify.error({
              title: 'Error',
              message: 'Unable to delete file.',
              duration: __WEBPACK_IMPORTED_MODULE_5__config_notify_constants__["a" /* default */].DURATION.SHORT
            });
          });
        }
      };
    },
    handleAdd: function handleAdd(type) {
      var _this3 = this;

      return function (response, file, fileList) {
        /**
         * Merge the response and file data together.
         * - `file` is needed to indicate the upload progress.
         * - `response` contain the actual file data from server
         *
         * keys in `response` will override the keys in `file`
         */
        var replacement = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, file, response);
        var index = fileList.findIndex(function (listFile) {
          return listFile.uid === file.uid;
        });

        _this3.$set(fileList, index, replacement);
        _this3.$set(_this3, 'fileListFor' + type, fileList);
      };
    },
    handleError: function handleError(err, file, fileList) {
      this.$notify.error({
        title: 'Error',
        message: err.target.status ? err.message || 'Unable to upload now. Please contact us if the error persist.' : 'Server stopped the uploading. This may happen if the file size exceed ' + (__WEBPACK_IMPORTED_MODULE_6__config_magic_values__["a" /* NGINX_UPLOAD_LIMIT */] / __WEBPACK_IMPORTED_MODULE_6__config_magic_values__["b" /* ONE_MEGABYTES */]).toFixed(0) + ' MB.',
        duration: __WEBPACK_IMPORTED_MODULE_5__config_notify_constants__["a" /* default */].DURATION.MEDIUM
      });
    }
  }
});

/***/ }),

/***/ 773:
/***/ (function(module, exports) {

var nestRE = /^(attrs|props|on|nativeOn|class|style|hook)$/

module.exports = function mergeJSXProps (objs) {
  return objs.reduce(function (a, b) {
    var aa, bb, key, nestedKey, temp
    for (key in b) {
      aa = a[key]
      bb = b[key]
      if (aa && nestRE.test(key)) {
        // normalize class
        if (key === 'class') {
          if (typeof aa === 'string') {
            temp = aa
            a[key] = aa = {}
            aa[temp] = true
          }
          if (typeof bb === 'string') {
            temp = bb
            b[key] = bb = {}
            bb[temp] = true
          }
        }
        if (key === 'on' || key === 'nativeOn' || key === 'hook') {
          // merge functions
          for (nestedKey in bb) {
            aa[nestedKey] = mergeFn(aa[nestedKey], bb[nestedKey])
          }
        } else if (Array.isArray(aa)) {
          a[key] = aa.concat(bb)
        } else if (Array.isArray(bb)) {
          a[key] = [aa].concat(bb)
        } else {
          for (nestedKey in bb) {
            aa[nestedKey] = bb[nestedKey]
          }
        }
      } else {
        a[key] = b[key]
      }
    }
    return a
  }, {})
}

function mergeFn (a, b) {
  return function () {
    a.apply(this, arguments)
    b.apply(this, arguments)
  }
}


/***/ }),

/***/ 774:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadDragShow_vue__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256780aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadDragShow_vue__ = __webpack_require__(778);
function injectStyle (ssrContext) {
  __webpack_require__(775)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadDragShow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_256780aa_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadDragShow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 775:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(776);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("63e631d3", content, true);

/***/ }),

/***/ 776:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".upload-drag-show{padding:1em 0;-webkit-box-sizing:border-box;box-sizing:border-box;background-color:transparent;-webkit-transition:background-color .5s;transition:background-color .5s}.upload-drag-show.dropping{background-color:rgba(0,0,0,.5)}.is-disabled+.el-upload.el-upload--picture-card{display:none}", "", {"version":3,"sources":["/app/src/components/Submission/steps/FilesMedia/UploadDragShow.vue"],"names":[],"mappings":"AAoHA,kBACE,cAAe,AACf,8BAA+B,AACvB,sBAAuB,AAC/B,6BAA8B,AAC9B,wCAA0C,AAC1C,+BAAkC,CACnC,AACD,2BACI,+BAAqC,CACxC,AACD,gDACE,YAAc,CACf","file":"UploadDragShow.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.upload-drag-show {\n  padding: 1em 0;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  background-color: transparent;\n  -webkit-transition: background-color 0.5s;\n  transition: background-color 0.5s;\n}\n.upload-drag-show.dropping {\n    background-color: rgba(0, 0, 0, 0.5);\n}\n.is-disabled + .el-upload.el-upload--picture-card {\n  display: none;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 777:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'file-list': {},
    'action': {},
    'headers': {},
    'on-add': {},
    'on-remove': {},
    'on-success': {},
    'on-error': {},
    'multiple': {},
    'data': {},
    'disabled': {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialogVisible: false,
      dialogImageUrl: '',
      isDropping: false
    };
  },

  computed: {
    dropIndicatorActive: function dropIndicatorActive() {
      // TODO: This function is disabled as it is still buggy.
      //       see https://stackoverflow.com/questions/7110353/html5-dragleave-fired-when-hovering-a-child-element
      return this.isDropping ? 'dropping' : '';
    }
  },
  methods: {
    handlePictureCardPreview: function handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    droppedFile: function droppedFile(e) {
      // TODO: Need to perform file format validation against the accept list
      this.preventDefault(e);
      if (this.disabled) return;

      var uploader = this.$refs['el-upload'].$children.find(function (child) {
        return child.name === 'file';
      });

      var files = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(e.dataTransfer.files));
      var areAllImages = files.every(function (fileObj) {
        return uploader.isImage(fileObj.type);
      });

      if (!areAllImages) {
        this.$message('You can only upload images here');
      } else {
        uploader.uploadFiles(files);
      }
    },
    preventDefault: function preventDefault(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  },
  mounted: function mounted() {}
});

/***/ }),

/***/ 778:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"upload-drag-show",class:_vm.dropIndicatorActive,on:{"drop":_vm.droppedFile,"drag":_vm.preventDefault,"dragstart":_vm.preventDefault,"dragend":_vm.preventDefault,"dragover":_vm.preventDefault,"dragenter":_vm.preventDefault,"dragleave":_vm.preventDefault}},[_c('el-upload',{ref:"el-upload",staticClass:"upload-drag-show__upload-wrapper",attrs:{"action":_vm.action,"headers":_vm.headers,"file-list":_vm.fileList,"on-remove":_vm.onRemove,"on-success":_vm.onSuccess,"on-add":_vm.onAdd,"data":_vm.data,"on-preview":_vm.handlePictureCardPreview,"on-error":_vm.onError,"accept":"image/*","multiple":_vm.multiple,"list-type":"picture-card","disabled":_vm.disabled}},[_c('i',{staticClass:"el-icon-plus",staticStyle:{"pointer-events":"none"}})]),_vm._v(" "),_c('el-dialog',{attrs:{"visible":_vm.dialogVisible},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('img',{attrs:{"width":"100%","src":_vm.dialogImageUrl,"alt":""}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 779:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubtitleUploader_vue__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490c749f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubtitleUploader_vue__ = __webpack_require__(783);
function injectStyle (ssrContext) {
  __webpack_require__(780)
}
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-490c749f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SubtitleUploader_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_490c749f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SubtitleUploader_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 780:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(781);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("1c970e7c", content, true);

/***/ }),

/***/ 781:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".subtitle-uploader__select[data-v-490c749f]{margin-left:-4px;margin-right:4px}", "", {"version":3,"sources":["/app/src/components/Submission/steps/FilesMedia/SubtitleUploader.vue"],"names":[],"mappings":"AAoHA,4CACE,iBAAkB,AAClB,gBAAkB,CACnB","file":"SubtitleUploader.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.subtitle-uploader__select[data-v-490c749f] {\n  margin-left: -4px;\n  margin-right: 4px;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 782:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_ISO693_1_json__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__assets_data_ISO693_1_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__assets_data_ISO693_1_json__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    'file-list': {},
    'action': {},
    'data': {},
    'headers': {},
    'on-add': {},
    'on-remove': {},
    'on-success': {},
    'on-change': {},
    'multiple': {},
    'disabled': {
      type: Boolean,
      default: false
    },
    'accept': {
      type: String,
      default: '*/*'
    }
  },
  data: function data() {
    return {
      langs: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_freeze___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_3__assets_data_ISO693_1_json___default.a).map(function (key) {
        return {
          value: key,
          label: __WEBPACK_IMPORTED_MODULE_3__assets_data_ISO693_1_json___default.a[key].name
        };
      })),
      isRendered: false
    };
  },

  computed: {
    uploaderList: function uploaderList() {
      return this.isRendered ? this.$refs.uploader.uploadFiles : [];
    }
  },
  methods: {
    handleRemove: function handleRemove(file) {
      var oldFileList = this.uploaderList;
      var newFileList = oldFileList.filter(function (listFile) {
        return listFile.uid !== file.uid;
      });

      this.onRemove(file, newFileList);
    },
    handleLanguageUpdate: function handleLanguageUpdate(file, newLanguage) {
      this.onChange(file, newLanguage);
    },
    parsePercentage: function parsePercentage(val) {
      return parseInt(val, 10);
    },
    pickedFile: function pickedFile(rawFile) {
      var uploader = this.$refs.uploader.$children.find(function (child) {
        return child.name === 'file';
      });
      var isSrtFile = rawFile.name.includes('.srt');

      if (!isSrtFile) {
        this.$message('You can only upload .srt files here');
      } else {
        uploader.uploadFiles(rawFile);
      }
      this.isAcceptedType = isSrtFile;
      return isSrtFile;
    }
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
      _this.isRendered = true;
    });
  }
});

/***/ }),

/***/ 783:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{ref:"uploader",attrs:{"action":_vm.action,"headers":_vm.headers,"data":{
      category: _vm.data.category,
      note: _vm.data.note || 'en',
    },"on-remove":_vm.onRemove,"on-success":_vm.onSuccess,"before-upload":_vm.pickedFile,"multiple":_vm.multiple,"file-list":_vm.fileList,"disabled":_vm.disabled,"show-file-list":false,"accept":_vm.accept}},[_vm._t("default")],2),_vm._v(" "),_c('transition-group',{class:[
      'el-upload-list',
      'el-upload-list--text',
      { 'is-disabled': _vm.disabled }
    ],attrs:{"tag":"ul","name":"el-list"}},_vm._l((_vm.uploaderList),function(item,index){return _c('li',{key:index,staticClass:"el-upload-list__item is-success",attrs:{"tabindex":"0"}},[_c('span',{staticClass:"el-upload-list__item-name"},[_c('i',{staticClass:"el-icon-document"}),_vm._v(" "),(typeof item.note === 'string')?_c('span',{staticClass:"subtitle-uploader__select"},[_c('el-select',{staticStyle:{"width":"160px"},attrs:{"value":item.note,"placeholder":"Select","size":"mini","filterable":""},on:{"change":function (note) { return _vm.handleLanguageUpdate(item, note); }}},_vm._l((_vm.langs),function(item){return _c('el-option',{key:item.value,attrs:{"label":item.label,"value":item.value}})}))],1):_vm._e(),_vm._v("\n        "+_vm._s(item.name)+"\n\n        "),_c('div',{staticStyle:{"clear":"both"}})]),_vm._v(" "),_c('label',{staticClass:"el-upload-list__item-status-label"},[_c('i',{staticClass:"el-icon-upload-success el-icon-circle-check"})]),_vm._v(" "),_c('i',{staticClass:"el-icon-close",on:{"click":function($event){_vm.handleRemove(item, _vm.fileList)}}}),_vm._v(" "),_c('i',{staticClass:"el-icon-close-tip"},[_vm._v("press delete to remove")]),_vm._v(" "),(item.status === 'uploading')?_c('el-progress',{attrs:{"type":'line',"stroke-width":2,"percentage":_vm.parsePercentage(item.percentage)}}):_vm._e()],1)}))],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 784:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMediaItem_vue__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf6d552_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMediaItem_vue__ = __webpack_require__(796);
var normalizeComponent = __webpack_require__(7)
/* script */

/* template */

/* template functional */
  var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FileMediaItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6bf6d552_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_FileMediaItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 785:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_upload__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_upload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_upload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FileMediaItemHeader__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__FileMediaItemDescription__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FileMediaItemListEmptyState__ = __webpack_require__(732);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_upload___default.a);

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FileMediaItem',
  components: {
    FileMediaItemHeader: __WEBPACK_IMPORTED_MODULE_2__FileMediaItemHeader__["a" /* default */],
    FileMediaItemDescription: __WEBPACK_IMPORTED_MODULE_3__FileMediaItemDescription__["a" /* default */],
    FileMediaItemListEmptyState: __WEBPACK_IMPORTED_MODULE_4__FileMediaItemListEmptyState__["a" /* default */]
  },
  props: {
    action: {
      type: String,
      required: true
    },
    accept: {
      type: String,
      default: '*/*'
    },
    requestHeaders: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    onRemove: {
      type: Function,
      required: true
    },
    onSuccess: {
      type: Function,
      required: true
    },
    fileList: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isAcceptedType: true
    };
  },

  methods: {
    pickedFile: function pickedFile(rawFile) {
      var isDuplicate = this.fileList.filter(function (file) {
        return file.name === rawFile.name;
      });
      var uploader = this.$refs['el-upload'].$children.find(function (child) {
        return child.name === 'file';
      });
      if (isDuplicate.length > 0) {
        this.$message('This file already exist');
        this.isAcceptedType = false;
        return false;
      }
      if (this.accept.includes('image')) {
        var isImage = uploader.isImage(rawFile.type);

        if (!isImage) {
          this.$message('You can only upload images here');
        }
        this.isAcceptedType = isImage;
      } else if (this.accept.includes('video')) {
        var isVideo = rawFile.type.includes('video');

        if (!isVideo) {
          this.$message('You can only upload videos here');
        }
        this.isAcceptedType = isVideo;
      } else if (this.accept.includes('srt')) {
        var isSrtFile = rawFile.type.includes('srt');

        if (!isSrtFile) {
          this.$message('You can only upload .srt files here');
        }
        this.isAcceptedType = isSrtFile;
      }
      uploader.uploadFiles(rawFile);
      return this.isAcceptedType;
    }
  }
});

/***/ }),

/***/ 786:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(787);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("3914e026", content, true);

/***/ }),

/***/ 787:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".file-media__item__header .el-button--text{padding:0}", "", {"version":3,"sources":["/app/src/components/Submission/steps/FilesMedia/FileMediaItemHeader.vue"],"names":[],"mappings":"AAoHA,2CACE,SAAW,CACZ","file":"FileMediaItemHeader.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.file-media__item__header .el-button--text {\n  padding: 0;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 788:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FileMediaItemHeader',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  }
});

/***/ }),

/***/ 789:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('sh-inliner',{staticClass:"file-media__item__header"},[_vm._t("default"),_vm._v("\n   \n  "),(!_vm.disabled)?_c('el-button',{attrs:{"icon":"el-icon-circle-plus","type":"text"}},[_vm._v("Add")]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 790:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(791);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(512)("3d2758fb", content, true);

/***/ }),

/***/ 791:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(511)(true);
// imports


// module
exports.push([module.i, ".file-media__item__desc{margin-top:.5em;margin-bottom:.5em}", "", {"version":3,"sources":["/app/src/components/Submission/steps/FilesMedia/FileMediaItemDescription.vue"],"names":[],"mappings":"AAoHA,wBACE,gBAAkB,AAClB,kBAAqB,CACtB","file":"FileMediaItemDescription.vue","sourcesContent":["/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* Font\n-------------------------- */\n/* Element Chalk Variables */\n/* Transition\n-------------------------- */\n/* Colors\n-------------------------- */\n/* 53a8ff */\n/* 66b1ff */\n/* 79bbff */\n/* 8cc5ff */\n/* a0cfff */\n/* b3d8ff */\n/* c6e2ff */\n/* d9ecff */\n/* ecf5ff */\n/* Link\n-------------------------- */\n/* Background\n-------------------------- */\n/* Border\n-------------------------- */\n/* Box-shadow\n-------------------------- */\n/* Fill\n-------------------------- */\n/* Font\n-------------------------- */\n/* Size\n-------------------------- */\n/* z-index\n-------------------------- */\n/* Disable base\n-------------------------- */\n/* Icon\n-------------------------- */\n/* Checkbox\n-------------------------- */\n/* Radio\n-------------------------- */\n/* Select\n-------------------------- */\n/* Alert\n-------------------------- */\n/* Message Box\n-------------------------- */\n/* Message\n-------------------------- */\n/* Notification\n-------------------------- */\n/* Input\n-------------------------- */\n/* Cascader\n-------------------------- */\n/* Group\n-------------------------- */\n/* Tab\n-------------------------- */\n/* Button\n-------------------------- */\n/* cascader\n-------------------------- */\n/* Switch\n-------------------------- */\n/* Dialog\n-------------------------- */\n/* Table\n-------------------------- */\n/* Pagination\n-------------------------- */\n/* Popover\n-------------------------- */\n/* Tooltip\n-------------------------- */\n/* Tag\n-------------------------- */\n/* Tree\n-------------------------- */\n/* Dropdown\n-------------------------- */\n/* Badge\n-------------------------- */\n/* Card\n--------------------------*/\n/* Slider\n--------------------------*/\n/* Steps\n--------------------------*/\n/* Menu\n--------------------------*/\n/* Rate\n--------------------------*/\n/* DatePicker\n--------------------------*/\n/* Loading\n--------------------------*/\n/* Scrollbar\n--------------------------*/\n/* Carousel\n--------------------------*/\n/* Collapse\n--------------------------*/\n/* Transfer\n--------------------------*/\n/* Header\n  --------------------------*/\n/* Footer\n--------------------------*/\n/* Main\n--------------------------*/\n/* Break-point\n--------------------------*/\n.file-media__item__desc {\n  margin-top: 0.5em;\n  margin-bottom: 0.5em;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),

/***/ 792:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FileMediaItemDescription'
});

/***/ }),

/***/ 793:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"file-media__item__desc"},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 794:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FileMediaItemListEmptyState',
  props: {
    fileList: {
      type: Array,
      required: true
    }
  }
});

/***/ }),

/***/ 795:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.fileList.length)?_c('p',{staticClass:"empty-data"},[_vm._v("\n  Nothing in the list...\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 796:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-upload',{ref:"el-upload",attrs:{"action":_vm.action,"headers":_vm.requestHeaders,"data":_vm.data,"on-remove":_vm.onRemove,"on-success":_vm.onSuccess,"before-upload":_vm.pickedFile,"multiple":"","file-list":_vm.fileList,"disabled":_vm.disabled,"accept":_vm.accept}},[_c('FileMediaItemHeader',{attrs:{"disabled":_vm.disabled}},[_vm._t("title")],2),_vm._v(" "),_c('FileMediaItemDescription',[_vm._t("description")],2)],1),_vm._v(" "),_c('FileMediaItemListEmptyState',{attrs:{"file-list":_vm.fileList}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 797:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"submission__file-media"},[_c('div',{staticClass:"file-media__item"},[_c('el-alert',{attrs:{"title":"This section is optional.","type":"info","show-icon":""}}),_vm._v(" "),_c('sh-spacer',{attrs:{"by":"1"}}),_vm._v(" "),_c('el-alert',{attrs:{"title":"Do not use special characters for the file name such as ~`!@#$%^&*()-_+={}[]|\\/:;'<>,.? etc.","type":"info","show-icon":""}}),_vm._v(" "),_c('sh-spacer',{attrs:{"by":"3"}})],1),_vm._v(" "),_c('FileMediaItem',{staticClass:"file-media__item",attrs:{"action":_vm.getUploadUrl('attachments'),"request-headers":_vm.requestHeaders,"data":{
      category: _vm.categories.STILLS,
    },"on-remove":_vm.handleRemove('Stills'),"on-success":_vm.handleAdd('Stills'),"file-list":_vm.fileListForStills,"disabled":!_vm.editable,"accept":'image/png'}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("Stills")])]),_vm._v(" "),_c('template',{attrs:{"slot":"description"},slot:"description"},[_vm._v("\n      Upload image stills from your film. Recommended specs: 1920x1080 in PNG \n    ")])],2),_vm._v(" "),_c('FileMediaItem',{staticClass:"file-media__item",attrs:{"action":_vm.getUploadUrl('attachments'),"request-headers":_vm.requestHeaders,"data":{
      category: _vm.categories.TRAILER,
    },"on-remove":_vm.handleRemove('Trailer'),"on-success":_vm.handleAdd('Trailer'),"file-list":_vm.fileListForTrailers,"disabled":!_vm.editable,"accept":'video/*'}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("Trailer")])]),_vm._v(" "),_c('template',{attrs:{"slot":"description"},slot:"description"},[_vm._v("\n      Upload your trailer. Recommended specs: 1920 x 1080 (16:9) in MP4 / MOV H.264\n    ")])],2),_vm._v(" "),_c('FileMediaItem',{staticClass:"file-media__item",attrs:{"action":_vm.getUploadUrl('attachments'),"request-headers":_vm.requestHeaders,"data":{
      category: _vm.categories.POSTERS,
    },"on-remove":_vm.handleRemove('Poster'),"on-success":_vm.handleAdd('Poster'),"file-list":_vm.fileListForPosters,"disabled":!_vm.editable,"accept":'image/png'}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("Poster")])]),_vm._v(" "),_c('template',{attrs:{"slot":"description"},slot:"description"},[_vm._v("\n      Upload your film’s poster key art. Recommended specs: 1920x1080 in PNG\n    ")])],2),_vm._v(" "),_c('div',{staticClass:"file-media__item"},[_c('SubtitleUploader',{attrs:{"action":_vm.getUploadUrl('attachments'),"headers":_vm.requestHeaders,"data":{
        note: 'en',
        category: _vm.categories.SUBTITLES,
      },"on-remove":_vm.handleRemove('Subtitles'),"on-success":_vm.handleAdd('Subtitles'),"on-change":_vm.handleChange('Subtitles'),"multiple":"","file-list":_vm.fileListForSubtitles,"disabled":!_vm.editable,"accept":'.srt'}},[_c('FileMediaItemHeader',{attrs:{"disabled":!_vm.editable}},[_c('h2',[_vm._v("Subtitles")])]),_vm._v(" "),_c('FileMediaItemDescription',[_vm._v("\n        Upload subtitle files. Recommended specs: SRT (SubRip Text) File, for burned-in subtitles: Helvetica Neue Reg with outline or Roboto Reg with outline – Size 42        ")])],1),_vm._v(" "),_c('FileMediaItemListEmptyState',{attrs:{"file-list":_vm.fileListForSubtitles}})],1),_vm._v(" "),_c('sh-spacer',{attrs:{"by":"3.5"}}),_vm._v(" "),_c('FileMediaItem',{staticClass:"file-media__item",attrs:{"action":_vm.getUploadUrl('attachments'),"request-headers":_vm.requestHeaders,"data":{
      category: _vm.categories.MUSIC_LICENSE,
    },"on-remove":_vm.handleRemove('MusicLicense'),"on-success":_vm.handleAdd('MusicLicense'),"file-list":_vm.fileListForMusicLicense,"disabled":!_vm.editable}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("Music License Usage Form/ Cue Sheets")])]),_vm._v(" "),_c('template',{attrs:{"slot":"description"},slot:"description"},[_vm._v("\n      Upload your license usage documents, or if you only have the confirmation over email, attach a screenshot.\n      We take music license infringement seriously. If you haven't acquired permissions for the audio tracks used in your work, please obtain them from the rightful owner or replace it before submitting to us.\n    ")])],2),_vm._v(" "),_c('sh-spacer',{attrs:{"by":"3.5"}}),_vm._v(" "),_c('FileMediaItem',{staticClass:"file-media__item",attrs:{"action":_vm.getUploadUrl('attachments'),"request-headers":_vm.requestHeaders,"data":{
      category: _vm.categories.OTHERS,
    },"on-remove":_vm.handleRemove('Others'),"on-success":_vm.handleAdd('Others'),"file-list":_vm.fileListForOthers,"disabled":!_vm.editable}},[_c('template',{attrs:{"slot":"title"},slot:"title"},[_c('h2',[_vm._v("Others")])]),_vm._v(" "),_c('template',{attrs:{"slot":"description"},slot:"description"},[_vm._v("\n        If you're submitting for Juree Asia Awards 2023, we encourage you to upload:"),_c('br'),_vm._v("\n        - Director Bio (Tell us about yourself and your filmmaking journey in maximum 100 words in .docx or .pdf file)"),_c('br'),_vm._v("\n        - Director Photo (upload your headshot in PNG with at least 300 ppi)\n    ")])],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ })

});


// WEBPACK FOOTER //
// js/6.28c0226eb1617192ad29.js